import { setHeartBeat } from '../api/wecom';
import { getEnvStr } from '../utils';
import { getCookie } from '../utils/cookie';
import { WX_USER_DATA } from '../utils/keys';

type HeartBeatData = {
    active_page_id: number; // 活动id
    active_page_name: string; // 活动name
    staff_id: number; // 推广人id
    type: 33 | 34; // 33:表单  34:商品
    wx_unionid?: string; // 微信unionid
    expire_time?: number; // 时间
    source?: string; //来源码
};

export default class HeartBeat {
    baseData: HeartBeatData;
    timer?: any;
    count = 0;
    constructor(args: HeartBeatData) {
        this.baseData = args;
    }

    /**
     * 开始心跳
     * @param interval 间隔 秒
     */
    start(interval = 3) {
        // 创建定时器
        this.timer = setInterval(() => {
            // 推送数据
            this.pushdata(interval);
            // 时间累积
            this.count += interval;
            // 超过两分钟，以5秒为频次发送
            if (this.count >= 120) {
                clearInterval(this.timer);
                this.start(5);
            }
        }, interval * 1000);
    }

    /**
     * 推送数据
     * @param interval 间隔时间
     */
    pushdata(interval = 3) {
        let wxUserInfo = getCookie(getEnvStr(WX_USER_DATA)) || {};
        let params: HeartBeatData = {
            ...this.baseData,
            expire_time: interval, // 间隔
            wx_unionid: wxUserInfo.UnionId || '',
        };
        // 若无unionid || 无推送人id 没有上报的必要
        if (!params.wx_unionid || !params.staff_id) return;

        // 发送数据
        setHeartBeat(params);
    }

    destory() {
        if (this.timer) clearInterval(this.timer);
        this.count = 0;
    }
}
